import Vue from 'vue';
import parseISO from 'date-fns/parseISO';
import get from 'lodash/get';

const formatDate = value => {
  const date = parseISO(value);

  if (isNaN(Date.parse(date))) {
    return value;
  }

  try {
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  } catch (e) {
    return value;
  }
};

export default Vue.mixin({
  methods: {
    formatDate,
    showResponseError({ response }) {
      window.Notify.warning(
        get(response, 'data.message', get(response, 'message', 'Something went wrong')),
      );
    },
  },

  filters: {
    date(value) {
      return formatDate(value);
    },
  },
});
